/* eslint-disable default-case */
import axios from "axios";
import xss from "xss";
import CONFIG from "../config";
// do not import from "utils/functions" to prevent circular inports
import console from "../utils/functions/console";
import { ApiClient, DefaultApi, FilialeLieferadresseChange, RequestAction, TanAuthRequest } from "rage_api";
import { toBooleanJN } from "../utils/functions/formatBoolean";

let restRoot = null;
let servletRoot = null;
let sessionId = null;
let bankId = null;
let authToken = null;
let appId = null;
let backToShopLink = CONFIG.LINK_BACK_TO_SHOP;
let token = null;
let rageRoot = "";
let contextRoot;
let mandantId = null;
let htmlId = null;
let isTouch = false;
let navigateState = null;
let renderLandingPage = true;
let verwaltung = false;
let sessionStart = 0;
let activeTimeout = true;
let timoutPopupStatus = null;
let beraterkennzeichen = "none";
let isMaKond = false;
let mandantLogo = null;
let loadingMaKond = false;
let defaultApi = null;
let shopListe = [];
let tanAuth = null;
let callcenter = false;
let lightShop = false;

function contextLink(path) {
  const contextMatch = new RegExp("^" + contextRoot);
  return String(path).replace(contextMatch, "/").replace(/^\//, contextRoot).replace(/\/{2,3}/, "/");
}

export default {

  //overall init of whole application
  initApp: function () {
  },

  // init of noblemetals
  init: function (appConfig) {
    mandantId = xss(sessionStorage.getItem("mandantId")) || null;
    // reading /evaluating environment
    if (window.location.pathname.indexOf(CONFIG.ANKAUF) > -1) {
      appId = CONFIG.applicationIdAnkauf;
      //Beim Ankauf darf man nur ein Produkt pro Bestellung haben
      backToShopLink = CONFIG.ANKAUF + CONFIG.LINK_BACK_TO_SHOP;
    } else {
      appId = CONFIG.applicationId;
      backToShopLink = CONFIG.LINK_BACK_TO_SHOP;
    }
    let tagConfig = {};
    if (appConfig.htmlId) {
      htmlId = appConfig.htmlId;
      let tag = document.getElementById(htmlId);
      tagConfig = tag ? tag.dataset : {};
    }

    const baseUrl = new URL(window.location.href);
    baseUrl.search = "";
    baseUrl.hash = "";
    if (!appConfig.approot) {
      appConfig.approot = baseUrl.origin;
    }
    if (!appConfig.contextRoot) {
      appConfig.contextRoot = baseUrl.pathname.replace(/\/{0,2}$/, "/");
    }
    if (CONFIG.VERSE_NEO) {
      contextRoot = baseUrl.pathname.replace(/\/{0,2}$/, "/");
      rageRoot = (CONFIG.RAGE_ROOT).replace(/\/{2,3}/, "/");
    } else {
      contextRoot = CONFIG.CONTEXT_ROOT;
      rageRoot = CONFIG.RAGE_ROOT;
    }
    restRoot = new URL(this.findInitVar("approot", appConfig, tagConfig) + rageRoot + "/" + mandantId).pathname;
    servletRoot = new URL(this.findInitVar("approot", appConfig, tagConfig) + rageRoot + "/").pathname.replace(/\/{0,3}$/, "");
    // detection of touch-devices
    isTouch = "ontouchstart" in window || "onmsgesturechange" in window;
    authToken = null;
    sessionId = null;
    axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
    const apiClient = new ApiClient(CONFIG.SHOP_ROOT);
    apiClient.defaultHeaders = { request: JSON.stringify(this.getRequestHeader()) };
    defaultApi = new DefaultApi(apiClient);
  },

  getContextRoot() {
    return String(contextRoot).replace(/\/{2,3}/, "/");
  },

  getRestRoot() {
    return restRoot;
  },

  getBackToShopLink: function () {
    let lightShop = this.isLightShop() ? "&lightShop=true":"";

    if (this.isVerseNeo() && this.isAnkaufShop()) {
      return contextLink(CONFIG.ANKAUF) + "?mandant=" + xss(localStorage.getItem("mandantIdLink")) + lightShop;
    }
    return contextLink(backToShopLink) + "?mandant=" + xss(localStorage.getItem("mandantIdLink")) + lightShop;
  },

  getBackToLandingPageLink: function () {
    if (this.isVerseNeo() || this.isDeuBa()) {
      return contextLink(contextRoot) +
        "?token=" + xss(authToken) +
        "&mandant=" + xss(mandantId) +
        (this.isVerwaltung()
          ? "&verwaltung=true"
          : ""
        ) +
        (this.isCallcenter()
          ? "&callcenter=true"
          : ""
        );
    }
    return contextLink(backToShopLink) + "?mandant=" + xss(localStorage.getItem("mandantIdLink"));
  },

  getLinkPath: (LINK_ID, data) => {
    let contextPath = contextLink(LINK_ID);
    if (CONFIG[LINK_ID]) {
      contextPath = contextLink(CONFIG[LINK_ID]);
    }
    if (data) {
      contextPath = contextPath.replace(/\/{0,3}$/, `/${data}`);
    }
    return contextPath;
  },

  getContextPath: (path) => {
    return contextLink(path);
  },

  contextNavigate: (navigate) => (path, state) => {
    const contextPath = contextLink(path);
    console.debug("navigate to", contextPath);
    navigateState = state;
    if (!state) {
      return navigate({ to: contextPath });
    }
    return navigate({ to: contextPath, ...state });
  },

  getContextNavigateState() {
    return navigateState || {};
  },

  getHtmlId: function () {
    return htmlId;
  },

  getBankId: function () {
    return bankId;
  },

  getAppType: function () {
    return String(appId).match(/^So/) ? "sorten" : "edelmetall";
  },

  getImgRoot: function () {
    return String(CONFIG.pathes.images).replace(/#{mandantId}/, mandantId);
  },

  getImgUrl: function (image) {
    return this.getImgRoot() +
      (this.isVerseNeo()
        ? String(image).replace(/(.*)\.[a-z]*$/i, "$1")
        : image
      );
  },

  getApi: function (root, headers = {}) {
    if (!root) {
      return defaultApi;
    } else {
      const apiClient = new ApiClient(root);
      apiClient.defaultHeaders = headers;
      return new DefaultApi(apiClient);
    }
  },

  getApiRequest: function (type) {
    const header = this.getRequestHeader();
    const request = JSON.stringify(header);

    switch (type) {
      case "auftragStorno":
        return ({ auftragsNummer, stornoText, bearbeiter }, callback) => {
          const { name, telefon, platz } = bearbeiter || {};
          const requestStorno = RequestAction.constructFromObject({
            header,
            storno: true,
            stornoText,
            reprint: false,
            anwName: name,
            anwTelefonNummer: telefon,
            anwOe: platz,
          });
          return defaultApi.action(mandantId, auftragsNummer, request, requestStorno, callback);
        };
      case "changeLieferadresse":
        return (data, callback) => {
          const filialeLieferadresseChange = FilialeLieferadresseChange.constructFromObject({ ...data, header });
          filialeLieferadresseChange.edelmetallLieferbarKz = toBooleanJN(filialeLieferadresseChange.edelmetallLieferbarKz);
          filialeLieferadresseChange.sortenLieferbarKz = toBooleanJN(filialeLieferadresseChange.sortenLieferbarKz);
          const lieferadressenNummer = data.lieferadressenNummer;
          return defaultApi.postLieferadresse(lieferadressenNummer, mandantId, filialeLieferadresseChange, { request }, callback);
        };
      case "getTanAuthDaten":
        return ({ auftragsNummer, tanAuth, token }, callback) =>
          defaultApi.getTanAuthDaten(mandantId, TanAuthRequest.constructFromObject({
            header,
            auftragsNummer,
            tanAuth,
            token
          }), callback);
    }
    if (this.isVerseNeo()) {
      switch (type) {
        case "auftragsListe":
          return (query, callback) => defaultApi.putAuftragList(mandantId, { header }, { ...query, request }, callback);
        case "auftragsListeExtended":
          return (query, callback) => defaultApi.putAuftragListExtended(mandantId, { header }, { ...query, request }, callback);
        case "auftrag":
          return (auftragsNummer, callback) => defaultApi.putAuftrag(mandantId, auftragsNummer, { header }, { request }, callback);
        case "edelmetallKursliste":
          return (callback) => defaultApi.putEmKursList(mandantId, { header }, { request }, callback);
        case "edelmetallKurslistePdf":
          return (opts, callback) => {
            // Support both old signature (callback only) and new signature (opts, callback)
            if (typeof opts === 'function') {
              callback = opts;
              opts = {};
            }
            return defaultApi.putEmKursListePdf(mandantId, request, { header }, opts, callback);
          };
        case "sortenKursliste":
          return (callback) => defaultApi.putSoKursList(mandantId, { header }, {}, callback);
        case "sortenKurslistePdf":
          return (opts, callback) => {
            // Support both old signature (callback only) and new signature (opts, callback)
            if (typeof opts === 'function') {
              callback = opts;
              opts = {};
            }
            return defaultApi.putSoKursListePdf(mandantId, request, { header }, opts, callback);
          };
        case "lieferadressen":
          return (callback) => defaultApi.putLieferadressenList(mandantId, { header }, {}, callback);
        case "orderPdf":
          return (orderId, callback) => defaultApi.putOrderPdf(orderId, mandantId, request, { header }, callback);
        case "auftragReprint":
          return (auftragsNummer, callback) => defaultApi.putAuftragPdf(mandantId, request, auftragsNummer, { header }, callback);
        default:
          throw new Error("Unbekannte api id");
      }
    } else {
      switch (type) {
        case "auftragsListe":
          return (query, callback) => defaultApi.getAuftragList(mandantId, request, query, callback);
        case "auftragsListeExtended":
          return (query, callback) => defaultApi.getAuftragListExtended(mandantId, request, query, callback);
        case "auftrag":
          return (auftragsNummer, callback) => defaultApi.getAuftrag(mandantId, auftragsNummer, request, callback);
        case "edelmetallKursliste":
          return (callback) => defaultApi.getEmKursList(mandantId, request, callback);
        case "edelmetallKurslistePdf":
          return (opts, callback) => {
            // Support both old signature (callback only) and new signature (opts, callback)
            if (typeof opts === 'function') {
              callback = opts;
              opts = {};
            }
            // Note: Query params will be added to the API once backend supports them
            return defaultApi.getEmKursListePdf(mandantId, request, opts, callback);
          };
        case "sortenKursliste":
          return (callback) => defaultApi.getSoKursList(mandantId, request, callback);
        case "sortenKurslistePdf":
          return (opts, callback) => {
            // Support both old signature (callback only) and new signature (opts, callback)
            if (typeof opts === 'function') {
              callback = opts;
              opts = {};
            }
            // Note: Query params will be added to the API once backend supports them
            return defaultApi.getSoKursListePdf(mandantId, request, opts, callback);
          };
        case "lieferadressen":
          return (callback) => defaultApi.getLieferadressenList(mandantId, request, callback);
        case "orderPdf":
          return (orderId, callback) => defaultApi.getOrderPdf(orderId, mandantId, request, callback);
        case "auftragReprint":
          return (auftragsNummer, callback) => defaultApi.getAuftragPdf(mandantId, request, auftragsNummer, callback);
        default:
          throw new Error("Unbekannte api id");
      }
    }
  },

  getRequestData: function (type, method = "get", dataToSend = {}, withCacheBuster = false) {
    // workaround for proxy issue in verseNeo to get headers
    if (this.isVerseNeo() && method === "get") {
      method = "put";
    }
    let data = this.setDataWithHeader(
      {
        request: {
          config: {}
        }
      },
      dataToSend
    );
    let url;
    switch (type) {
      // in standalone get - mit backend post
      case "masterdata":
      case "catalog":
        url = new URL(window.location.origin + restRoot + CONFIG.rest[type]);
        if (withCacheBuster) {
          url.searchParams.append("cachebuster", new Date().getTime());
        }
        if (isMaKond) {
          url.searchParams.append("isMaKond", isMaKond);
        }
        data.url = url.toString();
        data.request = this.getRequestConfigNeu(method);
        break;
      case "order":
      case "warenkorb":
        url = new URL(window.location.origin + restRoot + CONFIG.rest[type]);
        if (withCacheBuster) {
          url.searchParams.append("cachebuster", new Date().getTime());
        }
        data.url = url.toString();
        if (data.json && isMaKond) {
          data.json.isMaKond = isMaKond;
        }
        if (this.isDeuBa()) {
          data.json.kundenId = dataToSend.kundenId;
        }
        data.request = this.getRequestConfigNeu(method);
        break;
      case "basedata":
      case "session":
      case "session_ping":
      case "kunde":
      case "edelmetallKonditionen":
      case "edelmetallKonditionenAbsolut":
      case "sortenKonditionen":
      case "edelmetallStufen":
      case "sortenStufen":
      case "mandant":
      case "mandantOrderLimit":
      case "orderLimitBootstrap":
      case "yesLogin":
      case "yesResponseExt":
      case "orderPdf":
      case "deleteFile":
      case "exitApp":
      case "logon":
      case "logError":
      case "hinweise":
        data.url = restRoot + this.configureCacheBuster(CONFIG.rest[type], withCacheBuster);
        data.request = this.getRequestConfigNeu(method);
        break;
      case "sendeTlsCode":
        data.url = restRoot + this.configureCacheBuster(CONFIG.rest[type], withCacheBuster);
        data.request = this.getRequestConfigNeu(method);
        data.url = data.url + dataToSend.warenkorbId;
        break;
      case "loadContactImage":
        data.request = this.getRequestConfigNeu(method);
        url = new URL(window.location.origin + CONFIG.RAGE_ROOT + CONFIG.servlet.downloadImage.replace(/#{mandantId}/, mandantId).replace(/#{type}/, "contact"));
        url.searchParams.append("t", Math.floor(new Date().getTime() / 5000));
        data.url = url.toString();
        break;
      case "loadLogoImage":
        data.request = this.getRequestConfigNeu(method);
        url = new URL(window.location.origin + CONFIG.RAGE_ROOT + CONFIG.servlet.downloadImage.replace(/#{mandantId}/, mandantId).replace(/#{type}/, "headerbild"));
        data.url = url.toString();
        break;
      case "uploadFile":
      case "downloadFile":
      case "contactImage":
      case "logoImage":
        //erzeuge request type und config für http call
        data.request = this.getRequestConfigNeu(method);
        // /rage/mandantImageUpload?mandantId=2&imageType=logo
        data.url = servletRoot + this.configureCacheBuster(
          CONFIG.servlet[type].replace(/#{mandantId}/, mandantId),
          withCacheBuster
        );
        // mulitpart file statt json wird versendet      
        data.request.config = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        const formData = new FormData();
        formData.append("file", dataToSend);
        data.dataToSend = formData;
        data.header = this.getRequestHeader();
        break;
      default:
        data.request.type = "invalid";
        return data;
    }

    return data;
  },

  setDataWithHeader: function (data, dataToSend = {}) {
    let header = { header: this.getRequestHeader() };
    data.json = Object.assign(
      header,
      dataToSend
    );
    // data.json.(this.getRequestHeader());
    data.request = this.getRequestConfig();
    data.request.config = {};
    return data;
  },

  configureCacheBuster: function (path, withCacheBuster) {
    return withCacheBuster ? this.addCacheBuster(path) : path;
  },

  getRequestConfigNeu: function (method) {
    return {
      type: method,
      config: {
        headers: {
          "Content-Type": "application/json"
        }
      }
    };
  },

  getRequestConfig: function () {
    return {
      type: "get",
      config: {
        headers: {
          "Content-Type": "application/json"
        }
      }
    };
  },

  getAppPath: function (which) {
    return CONFIG.pathes[which];
  },

  addCacheBuster: function (url) {
    let d = new Date();
    url += String(url).indexOf("?") === -1 ? "?" : "&";
    return String(url) + "cachebuster=" + Math.floor(d.getTime() / 5000);
  },

  isKundenShop: function () {
    return !!String(appId).match(/(Rage|VNeo)(Em|So)Wl(Buy|Sell)/);
  },

  isMaShop: function () {
    return !!String(appId).match(/(Rage|VNeo)(Em|So)(Bp|Ma)(Buy|Sell)/);
  },

  isAnkaufShop: function () {
    return !!String(appId).match(/(Rage|VNeo)(Em|So)(Bp|Wl|Ma)Sell/);
  },

  isVerseNeo: function () {
    return !!String(appId).match(/VNeo/);
  },

  isDeuBa: function () {
    return CONFIG.isDeuBa();
  },

  hasHeader: function () {
    return !this.isVerseNeo();
  },

  hasFooter: function () {
    return !this.isVerseNeo();
  },

  hasMenu: function () {
    return !this.isVerseNeo() && !this.isDeuBa();
  },

  getCalculationTimeout: function () {
    if (isTouch) return CONFIG.calculationTimeoutTouch;
    return CONFIG.calculationTimeout;
  },

  getSessionId: function () {
    return sessionId;
  },

  setSessionId: function (id) {
    if (id && sessionId === null) {
      sessionId = xss(id);
      axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
    }
  },

  setSessionData: function (data) {
    if (!data) return;
    const newSessionId = data.header ? data.header.sessionId || data.sessionId : data.sessionId;
    if (newSessionId && sessionId === null) {
      sessionId = xss(newSessionId);
      sessionStart = Date.now();
      timoutPopupStatus = null;
      axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
    }
    if (data.token && token === null) {
      this.setAuthToken(data.token);
    }
    if (data.bankId && bankId === null) {
      bankId = xss(data.bankId);
    }
  },

  getSessionData() {
    const timeout = sessionStorage.getItem("timeout") || CONFIG.SESSION_TTL;
    return { sessionStart, timeout: timeout * 60, warningTime: CONFIG.SESSION_WARN * 60, isActive: activeTimeout };
  },

  setActiveTimeout(active) {
    activeTimeout = !!active;
  },

  setTimoutPopupStatus(status) {
    timoutPopupStatus = status;
  },

  getTimoutPopupStatus() {
    return timoutPopupStatus || "closed";
  },

  sessionWillEnd() {
    const time = Date.now();
    let warningTime = Math.max(0, CONFIG.SESSION_TTL - CONFIG.SESSION_WARN * 2) * 60 * 1000 + sessionStart;
    warningTime = Math.floor((warningTime - time) / 1000);
    return warningTime < 0;
  },

  resetSession: function () {
    sessionStart = Date.now();
    timoutPopupStatus = null;
  },

  getRenderLandingPage: function () {
    return renderLandingPage;
  },

  setRenderLandingPage(newValue) {
    renderLandingPage = !!newValue;
  },

  setTanAuth(value) {
    tanAuth = !!value;
    renderLandingPage = false;
  },

  isTanAuth() {
    return !!tanAuth;
  },

  isDataLoaderActive() {
    return (!this.isVerseNeo() || !!tanAuth) && !!sessionId;
  },

  kundeIsSelectable() {
    return !this.isVerseNeo() && !this.isDeuBa();
  },

  setRequestHeader: function (data) {
    if (!data) return;
    bankId = xss(data.bankId);
    sessionId = xss(data.sessionId);
    authToken = xss(data.authToken);
    axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
  },

  setAuthToken: function (token) {
    authToken = xss(token);
    axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
  },

  setBankId: function (id) {
    bankId = xss(id);
    axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
  },

  getAppId() {
    return appId;
  },

  setAppId(selectedAppId) {
    appId = selectedAppId;
    if (this.isAnkaufShop()) {
      backToShopLink = CONFIG.ANKAUF + CONFIG.LINK_BACK_TO_SHOP;
    } else {
      backToShopLink = CONFIG.LINK_BACK_TO_SHOP;
    }
    axios.defaults.headers.common["request"] = JSON.stringify(this.getRequestHeader());
  },

  setVerwaltung(isVerwaltung) {
    verwaltung = !!isVerwaltung;
  },

  isVerwaltung() {
    return verwaltung && !this.isKundenShop();
  },

  setCallcenter(isCallcenter) {
    callcenter = !!isCallcenter;
  },

  isCallcenter() {
    return callcenter;
  },

  setLightShop(isLightShop) {
    lightShop = !!isLightShop;
  },

  isLightShop() {
    return lightShop;
  },

  getRequestHeader: function () {
    let header = {
      applikationId: appId,
      bankId: bankId,
      timestamp: this.createTimestamp(),
      sessionId: sessionId,
      authToken: authToken,
      shopVariant: this.isDeuBa() ? 'deuba' : null,
      lightShop: this.isLightShop() ? 'true' : null
    };
    return header;
  },

  // creates a timestamp for requests as defined by the bayernLB doc ("2016-02-19 15:20:22.123")
  createTimestamp: function () {
    return new Date().toISOString().substring(0, 23);
  },

  findInitVar: function (key, appConfig, tagConfig) {

    if (appConfig.hasOwnProperty(key)) return appConfig[key];
    if (tagConfig.hasOwnProperty(key)) return tagConfig[key];
    return null;
  },

  getBase64: function (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  },

  setMandantLogo(svg) {
    if (String(svg).match("^data:image")) {
      mandantLogo = svg;
    } else {
      mandantLogo = "data:image/svg+xml," + encodeURIComponent(mandantLogo);
    }
  },

  getLogoImageUrl: function (params = "") {
    if (!mandantLogo || params) {
      const t = Math.floor(new Date().getTime() / 5000);
      return CONFIG.RAGE_ROOT +
        CONFIG.servlet.downloadImage.replace(/#{mandantId}/, mandantId).replace(/#{type}/, "headerbild") +
        (params ? "&" + params : "&t=" + t);
    } else {
      return mandantLogo;
    }
  },

  getContactImageUrl: function (params = "") {
    const t = Math.floor(new Date().getTime() / 5000);
    return CONFIG.RAGE_ROOT +
      CONFIG.servlet.downloadImage.replace(/#{mandantId}/, mandantId).replace(/#{type}/, "contact") +
      (params ? "&" + params : "&t=" + t);
  },

  getFileDownloadUrl: function () {
    return CONFIG.RAGE_ROOT + CONFIG.servlet.downloadFile.replace(/#{mandantId}/, mandantId);
  },

  isBLBAdmin: function () {
    return Number(mandantId) === 1;
  },

  setMasterData(data) {
    if (!data || !data.gebuehren) return;
    let beraterAttr;
    switch (appId) {
      case CONFIG.applicationId:
        beraterAttr = CONFIG.getShopConfig({
          edelmetall: "emVK",
          sorten: "soVK"
        });
        break;
      case CONFIG.applicationIdAnkauf:
        beraterAttr = CONFIG.getShopConfig({
          edelmetall: "emAK",
          sorten: "soAK"
        });
        break;
      default:
        beraterAttr = "undefined";
        break;
    }

    beraterkennzeichen = data.gebuehren[beraterAttr] || "none";
    shopListe = [];
    if (String(data.gebuehren.emKz).toUpperCase() === 'J') shopListe.push("edelmetall");
    if (String(data.gebuehren.soKz).toUpperCase() === 'J') shopListe.push("sorten");

  },

  getBeraterKennzeichen() {
    return beraterkennzeichen;
  },

  getShopListe() {
    return [...shopListe];
  },

  setMitarbeiterKonditionen(value) {
    isMaKond = !!value;
  },

  isMitarbeiterKonditionen() {
    return isMaKond;
  },

  setLoadingMaKond(bool) {
    loadingMaKond = !!bool;
  },

  isLoadingMaKond() {
    return loadingMaKond;
  },

  getMandantLogo() {
    return mandantLogo;
  },

};
